import { useCallback, useEffect, useState } from "react";
import {
  BreedingsData,
  fetchFarmerAllDataBreedings,
  fetchProviderAllDataBreedings,
} from "../../../../api/breeding";
import { useAccountStorage } from "../../../../hooks/useAccountStorage";
import { spaceForType } from "../../../../utils/roles";

const EMPTY_DATA: BreedingsData = { breedings: [], unassignedDevices: [] };

/**
 * Élevages avec leurs bâtiments et produits, rechargeables après une modification : ceux de
 * l'éleveur, ou ceux de ses clients pour un installateur. Les produits sans bâtiment sont
 * rendus à part, par entreprise.
 */
export const useFarmerBreedings = () => {
  const { getAccountStorage } = useAccountStorage();
  const isInstaller = spaceForType(getAccountStorage()?.type) === "installer";
  const [data, setData] = useState<BreedingsData>(EMPTY_DATA);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const reload = useCallback(async () => {
    try {
      setData(
        await (isInstaller
          ? fetchProviderAllDataBreedings()
          : fetchFarmerAllDataBreedings())
      );
      setHasError(false);
    } catch (fetchError) {
      console.error(fetchError);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [isInstaller]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { ...data, isLoading, hasError, reload };
};
